import React, { Component } from "react";
import axios from "axios";
import { fabric } from "fabric";
import * as _ from "lodash-joins";
import CS from "../../commons/services/Common";
import { withTranslation } from "react-i18next";
import { DrawingModuleModal } from "./translationUiConst";

var SCALE_FACTOR = 1;
var TEMPLATE_WIDTH = 600;
var TEMPLATE_HEIGHT = 500;
var TEMPMODULE_ID = "";
var TEMPINVERTER_ID = "";
var MODULE_SN = 0;
var isDrag = false;
var h = [];
// var PREV_GROUP;
// var PREV_GROUP_O;d

class DrawingModule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModal: false,
      batchType: "row",
      plantId: props.match.params.plantId,
      row: 5,
      col: 2,
      azimuth: 0,
      objCnt: 0,
      bModInfos: [],
      aModInfos: [],
      searchSerialNo: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.buildModule = this.buildModule.bind(this);

    this.modInfos = [];
  }

  componentDidMount = () => {
    this.buildCanvas();
    this.getModuleSerialNos();
  };

  buildCanvas() {
    this.canvas = this.__canvas = new fabric.Canvas("c");

    this.canvas.on("mouse:dblclick", (e) => {});

    //rotated, rotating
    this.canvas.on("object:rotating", (e) => {
      let idx = e.target._objects[0]._objects[1].text.split("&")[0];
      let angle = Math.round(this.canvas.toJSON().objects[idx].angle);
      this.setState({
        azimuth: angle < 0 ? angle + 360 : angle,
      });
    });

    this.canvas.on("object:moving", function (e) {
      //console.log(e.target);
    });
  }

  async getModuleSerialNos() {
    let drawModInfos = [];
    let drawInfos = await axios.get(
      `/usr/api/constructor-plant/inverter/${this.state.plantId}`
    );
    console.log("drawInfos", drawInfos);
    if (!CS.checkIsNull(drawInfos)) {
      let imgElement = document.getElementById("panel-image");
      const infos = drawInfos.data;
      infos.some((v1, i1) => {
        const inverterSerialNo = v1.serialNo;
        const modules = JSON.parse(v1?.modules || "[]");

        let moduleSn = 0;
        modules.some((v2, i2) => {
          const width = v2.batchType === "row" ? 15 : 30;
          const height = v2.batchType === "row" ? 30 : 15;
          const moduleSerialNo = v2.moduleSerialNo;

          let rect = new fabric.Rect({
            width: width,
            height: height,
            stroke: "red",
            fill: moduleSerialNo ? "#d6f71a" : "#00006F",
          });
          let text = new fabric.Text(
            moduleSn + "&" + moduleSerialNo + "&" + inverterSerialNo,
            {
              visible: false,
              fontSize: 0,
            }
          );

          let group = new fabric.Group([rect, text], {
            left: v2.leftX,
            top: v2.topY,
            angle: v2.azimuth,
            hasControls: false,
            draggable: false,
          });

          this.canvas.add(group);
          group.on("drop", function (e) {
            let text = this._objects[1].text;
            let idx = text.split("&")[0];
            this._objects[0].set("fill", "#d6f71a");
            this._objects[1].set("text", moduleSn + "&" + TEMPMODULE_ID);
            this.canvas.renderAll();
            isDrag = true;
          });

          /*
                    group.on("selected", function(e) {
                        const selectedGroup = this._objects[1].group.getPointByOrigin('center');
                        const selectedGroupO = this._objects[1].group;
                        if (PREV_GROUP) {
                            console.log(selectedGroup, PREV_GROUP)
                            const connector = new fabric.Line(
                                [PREV_GROUP.x, PREV_GROUP.y, selectedGroup.x, selectedGroup.y], {
                                  stroke: 'red',
                                  strokeWidth: 3,
                                  lockScalingX: true,
                                  lockScalingY: true,
                                  lockRotation: false,
                                  hasControls: false,
                                  hasBorders: false,
                                  lockMovementX: true,
                                  lockMovementY: true
                                }
                            )
                            
                            //*
                            PREV_GROUP_O.on('moving', function() {
                                const connectPoint = this.getPointByOrigin('center')
                                connector.set({
                                  x1: connectPoint.x,
                                  y1: connectPoint.y
                                })
                            })
                            selectedGroupO.on('moving', function() {
                                const connectPoint1 = this.getPointByOrigin('center')
                                connector.set({
                                  x2: connectPoint1.x,
                                  y2: connectPoint1.y
                                })
                            })
                            this.canvas.add(connector, PREV_GROUP_O, selectedGroupO);
                            /*1/
                            this.canvas.add(connector);
                        }
                        PREV_GROUP = selectedGroup;
                        PREV_GROUP_O = selectedGroupO;
                    });
                    */

          group.on("mouseover", function (e) {
            let text = this._objects[1].text.split("&")[1];
            if (text === "") {
              this._objects[0].set("fill", "rgba(255,199,214,100)");
              this.canvas.renderAll();
            }
          });
          group.on("mouseout", function (e) {
            let text = this._objects[1].text.split("&")[1];
            if (text === "") {
              this._objects[0].set("fill", "#00006F");
              this.canvas.renderAll();
            }
          });
          MODULE_SN = moduleSn;
          moduleSn++;

          if (moduleSerialNo !== "") {
            drawModInfos.push({
              inverterSerialNo: inverterSerialNo,
              moduleSerialNo: moduleSerialNo,
            });
          }

          if (i2 > 0) {
            /*
                        const rectz = rect.getPointByOrigin('center');
                        const recty = rect.getPointByOrigin('center');
                        const connector = new fabric.Line(
                            [rectz.x, rectz.y, recty.x, recty.y], {
                              stroke: '#8470ff',
                              strokeWidth: 3,
                              lockScalingX: true,
                              lockScalingY: true,
                              lockRotation: false,
                              hasControls: false,
                              hasBorders: false,
                              lockMovementX: true,
                              lockMovementY: true
                            }
                        )
                        */
          }
        });
      });
    }

    const infos = await axios.get(
      `/cst/api/mod-serial-infos/${this.state.plantId}`
    );
    if (typeof infos != "undefined") {
      this.setState({
        bModInfos: _.differenceBy(
          infos.data,
          drawModInfos,
          "inverterSerialNo",
          "moduleSerialNo"
        ),
        aModInfos: drawModInfos,
      });
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  };

  handleRemove = () => {
    if (isDrag) {
      let bModInfos = this.state.bModInfos.filter(
        (item) => item.moduleSerialNo !== TEMPMODULE_ID
      );
      let aModInfos = this.state.aModInfos;
      aModInfos.push({
        inverterSerialNo: TEMPINVERTER_ID,
        moduleSerialNo: TEMPMODULE_ID,
      });
      this.setState({
        bModInfos: bModInfos,
        sModInfos: bModInfos,
        aModInfos: aModInfos,
      });
    }
    isDrag = false;
  };

  buildInverter = () => {
    let inverter = new fabric.Rect({
      // bottom:300,
      top: 300,
      left: 300,
      fill: "grey",
      stroke: "grey",
      brightness: 0.7,
      width: 50,
      height: 50,
      strokeWidth: 2,
      cornersize: 10,
    });
    inverter.type = "inverter";

    this.canvas.add(inverter);
  };

  connectedLines = () => {
    alert(1);
  };

  buildModule = () => {
    let imgElement = document.getElementById("panel-image");
    let width = this.state.batchType === "row" ? 15 : 30;
    let height = this.state.batchType === "row" ? 30 : 15;
    let row = this.state.row;
    let col = this.state.col;
    let angle = this.state.azimuth;

    let groupPoint = {
      x: 0,
      y: 0,
    };

    let groups = new fabric.Group();
    for (let i = 0; i < col; i++) {
      let x1 =
        50 + (height + 2) * i * Math.sin(CS.calcDegressToRadian(360 - angle));
      let y1 =
        50 + (height + 2) * i * Math.cos(CS.calcDegressToRadian(360 - angle));

      for (let j = 0; j < row; j++) {
        const x2 = x1 + height * Math.sin(CS.calcDegressToRadian(360 - angle));
        const y2 = y1 + height * Math.cos(CS.calcDegressToRadian(360 - angle));
        const x3 = x2 + width * Math.cos(CS.calcDegressToRadian(360 - angle));
        const y3 = y2 - width * Math.sin(CS.calcDegressToRadian(360 - angle));
        const x4 = x3 - height * Math.sin(CS.calcDegressToRadian(360 - angle));
        const y4 = y3 - height * Math.cos(CS.calcDegressToRadian(360 - angle));

        let polygon = new fabric.Polygon(
          [
            { x: x1, y: y1 },
            { x: x2, y: y2 },
            { x: x3, y: y3 },
            { x: x4, y: y4 },
          ],
          {
            fill: "#00006F",
            stroke: "red",
            moduleSerialNo: null,
          }
        );

        let imgInstance = new fabric.Image(imgElement, {
          width: width,
          height: height,
          //opacity: 0.85,
        });

        let text = new fabric.Text(MODULE_SN++ + "&", {
          visible: false,
          fontFamily: "Courier New",
          fontSize: 10,
          fontSize: 0,
          left: x1,
          top: y1,
        });

        if (i == 0 && j == 0) {
          groupPoint.x = x2;
          groupPoint.y = y2;
        }

        let group = new fabric.Group([polygon, text], {
          hasControls: false,
          draggable: false,
        });
        group.type = "module";
        group.groupPoint = groupPoint;

        x1 = x1 + (width + 2) * Math.cos(CS.calcDegressToRadian(360 - angle));
        y1 = y1 - (width + 2) * Math.sin(CS.calcDegressToRadian(360 - angle));

        this.canvas.add(group);
        group.on("drop", function (e) {
          let text = this._objects[1].text;
          let idx = text.split("&")[0];
          this._objects[0].set("fill", "#d6f71a");
          this._objects[1].set(
            "text",
            idx + "&" + TEMPMODULE_ID + "&" + TEMPINVERTER_ID
          );
          this.canvas.renderAll();
          isDrag = true;
        });
        group.on("selected", function (e) {});
        group.on("mouseover", function (e) {
          let text = this._objects[1].text.split("&")[1];
          if (text === "") {
            this._objects[0].set("fill", "rgba(255,199,214,100)");
            this.canvas.renderAll();
          }
        });
        group.on("mouseout", function (e) {
          let text = this._objects[1].text.split("&")[1];
          if (text === "") {
            this._objects[0].set("fill", "#00006F");
            this.canvas.renderAll();
          }
        });
        //groups.addWithUpdate(group);
      }
    }
    this.modalHandler(false);
  };

  create = async () => {
    let array = [];
    let data = this.canvas.toJSON().objects;
    data.some((v) => {
      const polygon = v.objects[0];
      const text = v.objects[1];
      const moduleSerialNo = text.text.split("&")[1];
      const inverterSerialNo = text.text.split("&")[2];
      const width = v.width;
      const height = v.height;
      const batchType = width < 30 ? "row" : "col"; // 각각의 배치타입 적용
      
      if (
        !CS.checkIsNull(moduleSerialNo) &&
        !CS.checkIsNull(inverterSerialNo)
      ) {
        let param = {
          plantId: Number(this.state.plantId),
          moduleSerialNo: moduleSerialNo,
          inverterSerialNo: inverterSerialNo,
          azimuth: v.angle,
          leftX: v.left,
          topY: v.top,
          batchType: batchType,
        };
        array.push(param);
      }
    });

    const group = _.chain(array)
      .groupBy((v) => `${v.inverterSerialNo}`)
      .map((groups, inverterSerialNo) => ({ inverterSerialNo, groups }))
      .value();

    let params = [];
    group.some((v) => {
      params.push({
        plantId: Number(this.state.plantId),
        serialNo: v.inverterSerialNo,
        modules: JSON.stringify(v.groups),
        moduleSize: v.groups.length,
      });
    });
    let result = await CS.create(
      `/cst/api/constructor-plant/module/${this.state.plantId}`,
      params
    );
  };

  //fabric zoom in & out Event
  zoomInAndOut = (val) => {
    SCALE_FACTOR = Number(SCALE_FACTOR) + val;
    SCALE_FACTOR = Number(SCALE_FACTOR).toFixed(1);
    let tmWidth = TEMPLATE_WIDTH * SCALE_FACTOR;
    let tmHeight = TEMPLATE_HEIGHT * SCALE_FACTOR;
    this.canvas.setZoom(SCALE_FACTOR);
    this.canvas.calcOffset();
    this.canvas.renderAll();
  };

  undo = () => {
    if (this.canvas._objects.length > 0) {
      h.push(this.canvas._objects.pop());
      this.canvas.renderAll();
    }
  };

  redo = () => {
    if (h.length > 0) {
      //isRedoing = true;
      this.canvas.add(h.pop());
    }
  };

  deleteObject = () => {
    //let activeObject = this.canvas.getActiveObject();
    let selectedObjects = this.canvas.getActiveObjects();
    let deleteList = [];
    selectedObjects.some((v) => {
      let activeObject = v;
      let textArr = activeObject._objects[1].text.split("&");
      deleteList.push({
        moduleSerialNo: textArr[1],
        inverterSerialNo: textArr[2],
      });
      this.canvas.remove(activeObject);
    });

    if (deleteList.length > 0) {
      let bModInfos = this.state.bModInfos;
      let aModInfos = _.differenceBy(
        this.state.aModInfos,
        deleteList,
        "inverterSerialNo",
        "moduleSerialNo"
      );
      bModInfos = bModInfos.concat(deleteList);
      this.setState({
        bModInfos: bModInfos,
        aModInfos: aModInfos,
      });
    }
  };

  searchSerialNo = (e) => {
    this.setState({
      searchSerialNo: e.target.value,
    });
  };

  getSerialNo = (object) => {
    return object.text.split("&")[1];
  };

  modalHandler = (is) => {
    this.setState({
      isModal: is,
    });
  };

  chooseBatchType = (type) => {
    this.setState({
      batchType: type,
    });
  };

  render() {
    const { bModInfos, aModInfos, searchSerialNo, isModal, batchType } =
      this.state;

    const { t, i18n } = this.props;
    return (
      <>
        <div className="page-tit">
          <div className="container location">
            <h2 className="tit">{t('key437')}</h2>
            <span>
              <strong>{t('key438')}</strong>
            </span>
          </div>
        </div>
        <section className="module-match">
          <div className="container">
            <div className="h-stack">
              <div className="l-area">
                <div className="head">
                  <button type="button" className="btn blue w245 radius15">
                    <i className="material-icons size20">folder</i> {t('key439')}
                  </button>
                </div>
                <div className="card h654 py-25 px-12">
                  <div className="form-search1">
                    <form>
                      <input
                        type="text"
                        className="wp100 h45 center"
                        placeholder={t('key589')}
                        onChange={this.searchSerialNo}
                      />
                      <button type="submit" className="search-btn">
                        <i className="material-icons">search</i>
                      </button>
                    </form>
                  </div>
                  <div className="card3 h280 serial">
                    {bModInfos.map((row, i) => (
                      <>
                        {row.moduleSerialNo.indexOf(searchSerialNo) > -1 && (
                          <button
                            key={i}
                            type="button"
                            draggable="true"
                            className="white-label"
                            onDragStart={() => {
                              TEMPMODULE_ID = row.moduleSerialNo;
                              TEMPINVERTER_ID = row.inverterSerialNo;
                            }}
                            onDragEnd={this.handleRemove}
                          >
                            {row.moduleSerialNo}
                          </button>
                        )}
                      </>
                    ))}
                  </div>
                  <div className="size12 my-8 text-center">
                    {t('key453')}{" "}
                    <i className="material-icons size15">arrow_downward</i>
                  </div>
                  <div className="card3 h240 serial end">
                    {aModInfos.map((row, i) => (
                      <label
                        key={i}
                        className="white-label"
                        draggable="true"
                        onDragStart={() => {
                          TEMPMODULE_ID = row.moduleSerialNo;
                          TEMPINVERTER_ID = row.inverterSerialNo;
                        }}
                        onDragEnd={this.handleRemove}
                      >
                        {row.moduleSerialNo}
                      </label>
                    ))}
                  </div>
                </div>
              </div>
              <div className="r-area">
                <div className="head">
                  <button
                    type="button"
                    className="btn secondary w245 radius15"
                    onClick={() => this.modalHandler(true)}
                  >
                    <i className="material-icons size20">edit</i> {t('key440')}
                  </button>
                  <button
                    type="button"
                    className="btn primary2 radius15"
                    onClick={this.deleteObject}
                  >
                    <i className="material-icons size14">remove</i> {t('key449')}
                  </button>
                  <button
                    type="button"
                    className="btn primary2 radius15"
                    onClick={this.buildModule}
                  >
                    <i className="material-icons size14">add</i> {t('key450')}
                  </button>
                  <button
                    type="button"
                    className="btn primary2 radius15"
                    onClick={this.connectedLines}
                  >
                    <i className="material-icons size14">add</i> {t('key451')}
                  </button>
                </div>
                <div className="card m-map h654" style={{ overflow: "scroll" }}>
                  <canvas id="c" width="1500" height="1500"></canvas>
                  <div className="control-btn">
                    <button
                      type="button"
                      onClick={() => this.zoomInAndOut(0.1)}
                    >
                      <img src="/images/ctors/map/zoom-in.png" alt="확대" />
                    </button>
                    <button type="button">
                      <img
                        src="/images/ctors/map/zoom-reset.png"
                        alt="초기화"
                      />
                    </button>
                    <button
                      type="button"
                      onClick={() => this.zoomInAndOut(-0.1)}
                    >
                      <img src="/images/ctors/map/zoom-out.png" alt="축소" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="btn-areaC1">
              <button
                type="button"
                className="btn shadow1"
                onClick={this.create}
              >
                임시저장
              </button>
              <button
                type="button"
                className="btn primary"
                onClick={this.create}
              >
                등록완료
              </button>
              &nbsp;&nbsp;
            </div> */}
            <div className="btn-areaC2">
              <button
                type="submit"
                className="btn primary"
                onClick={this.create}
              >
                {t('key454')}
              </button>
            </div>
          </div>
        </section>

        <div
          className={isModal ? "modal show" : "modal"}
          id="directInputModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myModalLabel"
          aria-hidden="true"
        >
          <div className={`modal-dialog modal-dialog-centered `} style={{ width: 'fit-content', maxWidth: 'fit-content' }}>
            <div className="modal-content">
              <div className="modal-body">
                <div className="form-inline3 form-tit14">
                  <div className="form-group">
                    <label className={`tit ${DrawingModuleModal(i18n).labelWidthClass}`}>{t('key441')}</label>
                    <input
                      type="number"
                      className="w115 center"
                      name="row"
                      value={this.state.row}
                      onChange={this.handleInputChange}
                      min="0"
                      max="10"
                    />
                    <label className="tit ml-20">{t('key442')}</label>
                    <input
                      type="number"
                      className="w115 center"
                      name="col"
                      value={this.state.col}
                      onChange={this.handleInputChange}
                      min="0"
                      max="10"
                    />
                  </div>
                  <div className="form-group">
                    <label className={`tit ${DrawingModuleModal(i18n).labelWidthClass}`}>{t('key443')}</label>
                    <button
                      className={
                        batchType == "row"
                          ? "btn w145 h48 primary"
                          : "btn w145 h48 "
                      }
                      onClick={() => this.chooseBatchType("row")}
                    >
                      {/* 가로배치 */}
                      {t('key444')}
                    </button>
                    <button
                      className={
                        batchType == "col"
                          ? "btn w145 h48 ml-18 primary"
                          : "btn w145 h48 ml-18"
                      }
                      onClick={() => this.chooseBatchType("col")}
                    >
                      {/* 세로배치 */}
                      {t('key445')}
                    </button>
                  </div>
                  <div className="form-group">
                    <label className={`tit ${DrawingModuleModal(i18n).labelWidthClass}`}>{t('key446')}</label>
                    <input
                      type="tel"
                      className="w315 center"
                      name="azimuth"
                      value={this.state.azimuth}
                      onChange={this.handleInputChange}
                    />
                  </div>
                </div>
                <div className="foot-btn">
                  <button
                    type="button"
                    className="btn"
                    onClick={() => this.modalHandler(false)}
                  >
                    {t('key447')}
                  </button>
                  <button
                    type="button"
                    className="btn primary"
                    onClick={this.buildModule}
                  >
                    {t('key448')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(DrawingModule);
